import React from "react";
import ComicBase from "../ComicBase";

export default function ComicNaruto() {
  return (
    <ComicBase
      titulo="Hayami-san es INVIDENTE parte 1"
      portada="https://fullcomics18.org/img7/hayami-san-es-invidente1-1.jpg"
   paginas={[
  "https://fullcomics18.org/img7/hayami-san-es-invidente1-1.jpg",
  "https://fullcomics18.org/img7/hayami-san-es-invidente1-2.jpg",
  "https://fullcomics18.org/img7/hayami-san-es-invidente1-3.jpg",
  "https://fullcomics18.org/img7/hayami-san-es-invidente1-4.jpg",
  "https://fullcomics18.org/img7/hayami-san-es-invidente1-5.jpg",
  "https://fullcomics18.org/img7/hayami-san-es-invidente1-6.jpg",
  "https://fullcomics18.org/img7/hayami-san-es-invidente1-7.jpg",
  "https://fullcomics18.org/img7/hayami-san-es-invidente1-8.jpg",
  "https://fullcomics18.org/img7/hayami-san-es-invidente1-9.jpg",
  "https://fullcomics18.org/img7/hayami-san-es-invidente1-10.jpg",
  "https://fullcomics18.org/img7/hayami-san-es-invidente1-11.jpg",
  "https://fullcomics18.org/img7/hayami-san-es-invidente1-12.jpg",
  "https://fullcomics18.org/img7/hayami-san-es-invidente1-13.jpg",
  "https://fullcomics18.org/img7/hayami-san-es-invidente1-14.jpg",
  "https://fullcomics18.org/img7/hayami-san-es-invidente1-15.jpg",
  "https://fullcomics18.org/img7/hayami-san-es-invidente1-16.jpg",
  "https://fullcomics18.org/img7/hayami-san-es-invidente1-17.jpg",
  "https://fullcomics18.org/img7/hayami-san-es-invidente1-18.jpg",
  "https://fullcomics18.org/img7/hayami-san-es-invidente1-19.jpg",
  "https://fullcomics18.org/img7/hayami-san-es-invidente1-20.jpg",
  "https://fullcomics18.org/img7/hayami-san-es-invidente1-21.jpg",
  "https://fullcomics18.org/img7/hayami-san-es-invidente1-22.jpg",
  "https://fullcomics18.org/img7/hayami-san-es-invidente1-23.jpg",
  "https://fullcomics18.org/img7/hayami-san-es-invidente1-24.jpg",
  "https://fullcomics18.org/img7/hayami-san-es-invidente1-25.jpg",
  "https://fullcomics18.org/img7/hayami-san-es-invidente1-26.jpg",
  "https://fullcomics18.org/img7/hayami-san-es-invidente1-27.jpg",
  "https://fullcomics18.org/img7/hayami-san-es-invidente1-28.jpg",
  "https://fullcomics18.org/img7/hayami-san-es-invidente1-29.jpg",
  "https://fullcomics18.org/img7/hayami-san-es-invidente1-30.jpg",
  "https://fullcomics18.org/img7/hayami-san-es-invidente1-31.jpg",
  "https://fullcomics18.org/img7/hayami-san-es-invidente1-32.jpg",
  "https://fullcomics18.org/img7/hayami-san-es-invidente1-33.jpg",
  "https://fullcomics18.org/img7/hayami-san-es-invidente1-34.jpg"
]}
      sugeridos={[]}


      info={{
        grupo: "shoot the moon",
    tipo: "doujinshi",
    idioma: "Español",
    serie: "Original",
    personajes: [" "],
etiquetas: ["Ahegao", "BBM", "Beauty Mark", "Big Ass", "Big Breasts", "Blind", "Blowjob", "Bukkake", "Defloration", "Digital", "Glasses", "Gokkun", "Handjob", "Hidden Sex", "Huge Breasts", "Kissing", "Multi-work Series", "Nakadashi", "Netorare", "Rape", "Schoolboy Uniform", "Schoolgirl Uniform", "Sole Female", "Sole Male", "Sweating"],
    artistas: "Fuetakishi",
      }}
    />
  );
}

export const infoManga = {
  titulo: "Hayami-san es INVIDENTE parte 1",
  portada: "https://fullcomics18.org/img7/hayami-san-es-invidente1-1.jpg",
  reverso: "https://fullcomics18.org/img7/hayami-san-es-invidente1-10.jpg",
   fecha:"2026-05-16",


  info: {
    grupo: "shoot the moon",
    tipo: "doujinshi",
    idioma: "Español",
    serie: "Original",
    personajes: [" "],
etiquetas: ["Ahegao", "BBM", "Beauty Mark", "Big Ass", "Big Breasts", "Blind", "Blowjob", "Bukkake", "Defloration", "Digital", "Glasses", "Gokkun", "Handjob", "Hidden Sex", "Huge Breasts", "Kissing", "Multi-work Series", "Nakadashi", "Netorare", "Rape", "Schoolboy Uniform", "Schoolgirl Uniform", "Sole Female", "Sole Male", "Sweating"],
    artistas: "Fuetakishi",
  },
};
